import React from "react";
import "./productBox.scss";
import "react-slideshow-image/dist/styles.css";
import { Fade } from "react-slideshow-image";
import { carouselDetails, productBox } from "../../../constant";

const ProductBox = () => {
  return (
    <div className="productBox">
      <Fade cssClass="carousel" arrows={false} duration={1000}>
        {productBox.map((item) => (
          <div className="single" key={item.title}>
            <div className="text-container">
              <div className="title" style={{ color: item.textColor }}>
                {item.title}
              </div>
              <div
                className="subtitle"
                style={{ color: item.descriptionColor }}
              >
                {item.subtitle}
              </div>
            </div>
            <div className="img-container">
              <img src={item.image} alt={item.title} />
            </div>
          </div>
        ))}
      </Fade>
    </div>
  );
};

export default ProductBox;
